import { ApolloError } from "apollo-client";
import { AuthState } from "auth/reducer";
import { TasksState } from "tasks/reducer";
import { TaskMetricsFilterInput } from "typings/globalGQLTypes";

export const getTaskMetricsFilterInput = (
  authState: AuthState,
  dateEnd: string | null,
  dateStart: string | null,
  tasksState: TasksState,
): TaskMetricsFilterInput => {
  const cityId = authState.user?.cityId;
  const { priority: priorities, taskType: taskTypes } = tasksState.filters;

  return {
    cityIds: [cityId || ""],
    dateEnd,
    dateStart,
    priorities: priorities && priorities.length > 0 ? priorities : undefined,
    taskTypes: taskTypes && taskTypes.length > 0 ? taskTypes : undefined,
  };
};

export const getServiceUnavailableError = (error: ApolloError | undefined) => {
  return error?.message.includes("Service unavailable");
};
